import { NgModule } from '@angular/core';
import { ClockPipe } from './clock';
import { CnpjPipe } from './cnpj';
import { CpfPipe } from './cpf';
import { DatePipe } from './date';
import { JsonPipe } from './json';
import { NormalizePipe } from './normalize';
import { NumberPipe } from './number';
import { SanitizePipe } from './sanitize';
import { TimePipe } from './time';
import { TranslatePipe } from './translate';

export const CUSTOM_PIPES = [CnpjPipe, CpfPipe, DatePipe, JsonPipe, NormalizePipe, NumberPipe, SanitizePipe, TimePipe, TranslatePipe];

@NgModule({
  imports: [ClockPipe],
  exports: [CUSTOM_PIPES, ClockPipe],
  declarations: [CUSTOM_PIPES],
})
export class PipesModule {}
